import {
  ATTRIBUTE_TYPES_FAILURE,
  ATTRIBUTE_TYPES_REQUEST,
  ATTRIBUTE_TYPES_RESET,
  ATTRIBUTE_TYPES_SUCCESS,
} from "../actions/attributes";

const initialState = {
  state: "idle",
};

export default function attribute_types(state = initialState, action) {
  switch (action.type) {
    case ATTRIBUTE_TYPES_REQUEST:
      return {
        ...state,
        state: "loading",
      };
    case ATTRIBUTE_TYPES_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        state: "success",
      };
    }
    case ATTRIBUTE_TYPES_FAILURE:
      return {
        ...state,
        ...action.payload,
        state: "failure",
      };
    case ATTRIBUTE_TYPES_RESET:
      return {
        ...state,
        state: "idle",
      };

    default:
      return state;
  }
}
// ---------------------------------------------------------

import {
  ATTRIBUTES_FAILURE,
  ATTRIBUTES_REQUEST,
  ATTRIBUTES_RESET,
  ATTRIBUTES_SUCCESS,
} from "../actions/attributes";

// interface AttributesState {
//   state: string;
//   list: any[]; 
//   more?: boolean;
// }

// const initialStateAttr: AttributesState = {
//   state: "idle",
//   list: [],
//   more: false,
// };

export function attributes(state = initialState, action) {
  switch (action.type) {
    case ATTRIBUTES_REQUEST:
      return {
        ...state,
        state: "loading",
      };
    case ATTRIBUTES_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        state: "success",
      };
    }
    case ATTRIBUTES_FAILURE:
      return {
        ...state,
        ...action.payload,
        state: "failure",
      };
    case ATTRIBUTES_RESET:
      return {
        ...state,
        state: "idle",
      };

    default:
      return state;
  }
}

// ---------------------------------------------------------

import {
  ATTRIBUTES_POST_FAILURE,
  ATTRIBUTES_POST_REQUEST,
  ATTRIBUTES_POST_RESET,
  ATTRIBUTES_POST_SUCCESS,
} from "../actions/attributes";


export function addAttributes(state = initialState, action) {
  switch (action.type) {
    case ATTRIBUTES_POST_REQUEST:
      return {
        ...state,
        state: "loading",
      };
    case ATTRIBUTES_POST_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        state: "success",
      };
    }
    case ATTRIBUTES_POST_FAILURE:
      return {
        ...state,
        ...action.payload,
        state: "failure",
      };
    case ATTRIBUTES_POST_RESET:
      return {
        ...state,
        state: "idle",
      };

    default:
      return state;
  }
}
// ------------------------


import {
  DOC_EDIT_ATTRIBUTE_REQUEST,
  DOC_EDIT_ATTRIBUTE_SUCCESS,
  DOC_EDIT_ATTRIBUTE_FAILURE,
  DOC_EDIT_ATTRIBUTE_RESET,
} from "../actions/attributes";


export function editDocAttributes(state = initialState, action) {
  switch (action.type) {
    case DOC_EDIT_ATTRIBUTE_REQUEST:
      return {
        ...state,
        state: "loading",
      };
    case DOC_EDIT_ATTRIBUTE_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        state: "success",
      };
    }
    case DOC_EDIT_ATTRIBUTE_FAILURE:
      return {
        ...state,
        ...action.payload,
        state: "failure",
      };
    case DOC_EDIT_ATTRIBUTE_RESET:
      return {
        ...state,
        state: "idle",
      };

    default:
      return state;
  }
}

// -------------------------
import {
  DOCS_EDIT_ATTRIBUTE_REQUEST,
  DOCS_EDIT_ATTRIBUTE_SUCCESS,
  DOCS_EDIT_ATTRIBUTE_FAILURE,
  DOCS_EDIT_ATTRIBUTE_RESET,
} from "../actions/attributes";


export function editDocsAttributes(state = initialState, action) {
  switch (action.type) {
    case DOCS_EDIT_ATTRIBUTE_REQUEST:
      return {
        ...state,
        state: "loading",
      };
    case DOCS_EDIT_ATTRIBUTE_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        state: "success",
      };
    }
    case DOCS_EDIT_ATTRIBUTE_FAILURE:
      return {
        ...state,
        ...action.payload,
        state: "failure",
      };
    case DOCS_EDIT_ATTRIBUTE_RESET:
      return {
        ...state,
        state: "idle",
      };

    default:
      return state;
  }
}

// -------------------------

import {
  ATTRIBUTE_EDIT_REQUEST,
  ATTRIBUTE_EDIT_SUCCESS,
  ATTRIBUTE_EDIT_FAILURE,
  ATTRIBUTE_EDIT_RESET,
} from "../actions/attributes";


export function editAttribute(state = initialState, action) {
  switch (action.type) {
    case ATTRIBUTE_EDIT_REQUEST:
      return {
        ...state,
        state: "loading",
      };
    case ATTRIBUTE_EDIT_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        state: "success",
      };
    }
    case ATTRIBUTE_EDIT_FAILURE:
      return {
        ...state,
        ...action.payload,
        state: "failure",
      };
    case ATTRIBUTE_EDIT_RESET:
      return {
        ...state,
        state: "idle",
      };

    default:
      return state;
  }
}
// -------------------------

import {
  ATTRIBUTE_DELETE_REQUEST,
  ATTRIBUTE_DELETE_SUCCESS,
  ATTRIBUTE_DELETE_FAILURE,
  ATTRIBUTE_DELETE_RESET,
} from "../actions/attributes";


export function deleteAttribute(state = initialState, action) {
  switch (action.type) {
    case ATTRIBUTE_DELETE_REQUEST:
      return {
        ...state,
        state: "loading",
      };
    case ATTRIBUTE_DELETE_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        state: "success",
      };
    }
    case ATTRIBUTE_DELETE_FAILURE:
      return {
        ...state,
        ...action.payload,
        state: "failure",
      };
    case ATTRIBUTE_DELETE_RESET:
      return {
        ...state,
        state: "idle",
      };

    default:
      return state;
  }
}
